import React from 'react';
import { Landing } from './pages/Landing';
interface AppProps {
  /** Shows the launch checklist panel (missing checkout, price, legal links). Never visible to customers by default. */
  showEditorNotes?: boolean;
}
export function App({
  showEditorNotes = false
}: AppProps) {
  return <Landing showEditorNotes={showEditorNotes} data-id="element-0" data-mp="3farfxtucjy5o" />;
}